/* Version: 3.5.155 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '../../utils/functions.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { CardWrapper } from './styledComponents.js';
import { jsx } from 'react/jsx-runtime';
import useDerivedState from '../../hooks/useDerivedState.js';
import useId from '../../hooks/useId.js';
import useTheme from '../../hooks/useTheme.js';

var _excluded = ["id", "children", "customStyle", "centered"];
var Card = function Card(_ref) {
  var controlledId = _ref.id,
    children = _ref.children,
    _ref$customStyle = _ref.customStyle,
    customStyle = _ref$customStyle === undefined ? {
      cardStyle: {},
      cardImageStyle: {},
      cardActionStyle: {},
      contentStyle: {}
    } : _ref$customStyle,
    _ref$centered = _ref.centered,
    centered = _ref$centered === undefined ? false : _ref$centered,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useDerivedState = useDerivedState(useId('card-id-'), controlledId),
    _useDerivedState2 = _slicedToArray(_useDerivedState, 1),
    id = _useDerivedState2[0];
  var theme = useTheme();
  var safeProps = safeRest(rest);
  var _safeCustomStyle = safeCustomStyle(customStyle),
    cardStyle = _safeCustomStyle.cardStyle;
  var content = children && React.Children.map(children, function (child) {
    if (!child || !child.type) {
      return child;
    }
    return /*#__PURE__*/React.cloneElement(child, {
      centered: centered
    });
  });
  return /*#__PURE__*/jsx(CardWrapper, _objectSpread(_objectSpread({
    id: id,
    "data-testid": "card-wrapper",
    cardStyle: cardStyle,
    centered: centered,
    theme: theme
  }, safeProps), {}, {
    children: content
  }));
};
process.env.NODE_ENV !== "production" ? Card.propTypes = {
  /** ID is required for Automated Testing, Google analytics and Google Tag Manager */
  id: PropTypes.string,
  /** Flag to centre the contents of a Card */
  centered: PropTypes.bool,
  /** children */
  children: PropTypes.node.isRequired,
  /** Style overrides */
  customStyle: PropTypes.shape({
    cardStyle: PropTypes.object
  })
} : undefined;
process.env.NODE_ENV !== "production" ? Card.displayName = 'Card' : undefined;

export { Card as default };
